<template>
  <div class="text--small fz-14" v-if="chargeRemarks && chargeRemarks.length > 0">
    <div v-for="(item,index) in chargeRemarks" :key="index" class="mb-2">
      <charge-remarks-line :line="item" />
    </div>
  </div>
</template>

<script>
import chargeRemarksLine from './chargeRemarksLine.vue'
export default {
  components: { chargeRemarksLine },
  props: {
    chargeRemarks: Array
  }
}
</script>
